function initCollectionSwatches() {
  const swatches = document.querySelectorAll('.card-information .connected-product-slide');

  function handleSetSwatchImage() {
    const swatchSlide = this;
    const swatchImageSrc = swatchSlide.dataset.featuredImage.replace(/.*?(\/\/cdn.*)/, '$1');
    const cardWrapper = swatchSlide.closest('.card-wrapper');
    const cardImage = cardWrapper.querySelector('.card--product img:last-child');
    let cardImageInitSrc = cardWrapper.getAttribute('data-current-src');
    let cardImageInitSrcsetContent = cardImage.getAttribute('srcset');

    if (!cardImageInitSrc) {
      cardImageInitSrc = cardImage.currentSrc.replace(/.*?(\/\/cdn.*)/, '$1');
      cardWrapper.setAttribute('data-current-src', cardImageInitSrc);
    }

    if (!cardWrapper.getAttribute('data-original-srcset')) {
      cardWrapper.setAttribute('data-original-srcset', cardImageInitSrcsetContent);
    }

    cardImage.setAttribute('srcset', swatchImageSrc);
    cardWrapper.classList.add('focus-connected-product');
    cardWrapper.classList.remove('focus-second-image');
  }

  function handleUnsetSwatchImage() {
    const swatchSlide = this;
    const cardWrapper = swatchSlide.closest('.card-wrapper');
    const cardImage = cardWrapper.querySelector('.card--product img:last-child');
    const originalSrcset = cardWrapper?.dataset.originalSrcset;
    if (originalSrcset) cardImage.setAttribute('srcset', originalSrcset);
    cardWrapper.classList.remove('focus-connected-product');
    cardWrapper.classList.add('focus-second-image');
  }

  swatches.forEach(swatch => {
    swatch.addEventListener('mouseenter', handleSetSwatchImage);
    swatch.addEventListener('mouseleave', handleUnsetSwatchImage);
  });
}

window.addEventListener('load', initCollectionSwatches);
['swiper-initiated', 'loaded-recommendations'].forEach((event) => {
  document.addEventListener(event, () => {
    initCollectionSwatches();
  });
});

// Product page
const pdpSwatches = document.querySelectorAll('.pdp-connected-product');
const swatchesHeaderPlaceholder = document.querySelector('.hovered-swatch-name');

function setHeader() {
  const swatch = this;
  const swatchHeading = swatch.getAttribute('data-connected-product-heading');
  swatchesHeaderPlaceholder.innerText = swatchHeading;
  swatchesHeaderPlaceholder?.classList.add('active');
}

function unsetHeader() {
  swatchesHeaderPlaceholder?.classList.remove('active');
}

pdpSwatches.forEach(swatch => {
  swatch.addEventListener('mouseenter', setHeader);
  swatch.addEventListener('mouseleave', unsetHeader);
})